
const partialButton = require('rhythm-fe-ui-components/src/uiPartials/buttons/uiButton.hbs');

define(function (require) {
	var getTable = function (ele, readOnlyForm, detailOptions) {
		//set defaults for canAdd / canEdit / canDelete attributes. 11.2 does NOT send these if the value is true.

		ele.canAdd = ele.canAdd !== false;
		ele.canEdit = ele.canEdit !== false;
		ele.canDelete = ele.canDelete !== false;
		var el = $('<div/>', {
			'class': 'grid-wrapper',
			'data-parentdetailpageid':detailOptions.detailPageId
		});

		var fieldset = $('<fieldset/>');
		el.append(fieldset);
		if(ele.isEnabled === false){
			el.addClass('readOnly');
		}

		var titleWrapper = $('<div/>', {
			'class': 'grid-title-wrapper',
		});

		var label = $('<legend/>', {
			'class': 'grid-title',
		});
		// the grid title
		label.text(ele.text);
		titleWrapper.append(label);
		fieldset.append(titleWrapper);
		var gridBind = detailOptions.isGrid ? 'root': ele.bind;

		if (!readOnlyForm && ele.isEnabled && ele.canAdd) {
			var btnLabel = i18n.t('CIVICS.INSTRUMENT_SUBMIT.ADD_ROW');
			var btn = $('<button class="btn-icon btn-modal-row-add desktop-button"> <svg class="icon add"> <use xlink:href="#civics-add"></use> </svg>'+'&nbsp;'+btnLabel+'</button>');
			var mobileButton  = $(partialButton($.extend({}, {
				classes:'btn-modal-row-add mobile-add mobile-button',
				customAttr:'title="'+btnLabel+'" areia-label="'+btnLabel+'"',
				text:btnLabel,
				type:'primary'
			})));
			titleWrapper.append(btn);
			titleWrapper.append(mobileButton);
		}

		//scrolling divs
		var scrollWrap = $('<div/>',{class:'scrolling-table-wrapper'});
		var scrollRegion = $('<div/>',{class:'scrolling-table-scroll-region'});
		// create table element
		var table = $('<table/>', {
			'name': gridBind,
			'data-moniker': ele.moniker,
			'class': 'grid-table',
			'data-newrowcount':0,//this is used as the ID for all NEW rows. If you don't have a different number for each, only the last new row will save.
			'data-gridelements':JSON.stringify(ele.elements),
		});
		var tbody = $('<tbody/>', {'class': 'grid-body'});

		// create header row
		var thead = $('<thead/>', {'class': 'grid-header'});
		var tr = $('<tr/>', {
			'class': 'grid-row',
		});
		//create header cell for edit button
		if (!readOnlyForm && ele.isEnabled) {
			var editTH = $('<th/>', {
				'data-editoptions':true,
				'data-isAdd': detailOptions.isAdd === true,
				'data-canedit':ele.canEdit !== false,
				class:'grid-head edit'
			});
			tr.append(editTH);
		}
		// create a column for the delete button if it's not read only
		if (!readOnlyForm && ele.isEnabled === true) {
			var th = $('<th/>', {
				'data-rule': 'rowDeleted',
				'data-candelete':ele.canDelete === false ? false : true,
				'class': 'grid-head delete',
				'data-isAdd': detailOptions.isAdd === true
			});
			tr.append(th);
		}
		// create header cell for each column
		_.forEach(ele.elements, e => {
			var th = $('<th/>', {
				'data-bind': e.bind,
				'data-type': !_.isEmpty(e.type) ? e.type.toLowerCase() : '',
				'data-dataType': !_.isEmpty(e.dataType) ? e.dataType.toLowerCase() : '',
				'data-isRequired': e.isRequired,
				'data-isVisible': e.isVisible,
				'data-readOnlyForm': true,
				'data-format': e.format,
				'class': 'grid-head',
				'data-isKeyValue': e.isKeyValue,
				'data-isEnabled': e.isEnabled,
				'data-moniker': e.moniker,
				'data-text':e.text
			});
			th.append(thSpan);
			if (!e.isVisible) {
				th.addClass('hidden');
			}
			if(e.maxLength){
				th.attr('data-maxLength',e.maxLength);
			}

			var thSpan = $('<span/>', {});
			if(e.description){
				thSpan.attr('data-tooltip',e.description);
			}
			thSpan.text(e.text);
			if(e.isRequired){
				thSpan.text(e.text+' ');
				thSpan.append($('<em>').addClass('required').attr('aria-hidden','true').text('*'));
			}
			th.append(thSpan);
			tr.append(th);
		});

		thead.append(tr);
		table.append(thead);
		table.append(tbody);
		scrollRegion.append(table);
		scrollWrap.append(scrollRegion);
		fieldset.append(scrollWrap);

		return el;
	};
	return {
		getTable: function (ele, readOnlyForm, detailOptions) {
			return getTable(ele, readOnlyForm, detailOptions);
		}
	}
});